<template>
  <div class="grid crud-demo">

    <div class="col-12">
      <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{ msg.content }}</Message>
      <Toast />

      <CardProcesso :processo="processo"/>

      <div class="card"  v-if="temProcessos">
        <Toolbar class="mb-4" v-if="this.processo.estadoSelecao.cod > 2">
          <template #start> </template>
          <template #end>
            <Button label="Exportar Ampla com Contato" icon="pi pi-upload" class="p-button-help" @click="exportarResultadoAmplaContato"/>
            <Button label="Exportar Ampla" icon="pi pi-upload" class="m-2 p-button-help" @click="exportarResultadoAmpla"/>
            <Button label="Exportar Reservadas" icon="pi pi-upload" class="m-2 p-button-help" @click="exportarResultadoDeficiencia"/>
            <Button label="Exportar Convênio" icon="pi pi-upload" class="m-2 p-button-help" @click="exportarResultadoConvenio"/>
          </template>
        </Toolbar>

        <Panel v-for="resultadoArea in listaSeleacaoArea" :key="resultadoArea.area.id" :collapsed="true" @toggle="onToggle(resultadoArea)"
                class="col-12 md:col-12 justify-content-center p-0" :toggleable="true">
          <template #header>
            <label class="font-bold">Resultado: {{resultadoArea.area.nome}}</label>
          </template>

          <TabView class="col-12 md:col-12" scrollable >
            <TabPanel header="Ampla Concorrência">
              <DataTableResultadoVue titulo="Ampla Concorrência" :listaResultado="resultadoArea.listaAmpla" :processoSeletivo="processo"/>
            </TabPanel>
            <TabPanel header="Candidatos com Deficiência">
              <DataTableResultadoVue titulo="Candidatos com Deficiência" :listaResultado="resultadoArea.listaDeficiencia" :processoSeletivo="processo"/>
            </TabPanel>
            <TabPanel header="Candidatos Convênio">
              <DataTableResultadoVue titulo="Candidatos Convênio" :listaResultado="resultadoArea.listaConvenio" :processoSeletivo="processo"/>
            </TabPanel>
          </TabView>

        </Panel>

        <div>
          <Button class="mr-6 mb-2 mt-3" label="Gerar resultado" type="submit" style="width: 150px" @click="gerarResutadoSelecaoEstagioGeral()"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProcessoService from "../../service/ProcessoService";
import InscricaoService from "../../service/InscricaoService";
import { FilterMatchMode } from "primevue/api";
import CardProcesso from "../../components/CardProcesso.vue";
import { tratamentoDeErros } from "@/tratamentoDeErros";
import DataTableResultadoVue from "../../components/resultado/DataTableResultado.vue";

export default {
  mixins: [tratamentoDeErros],
  components: { CardProcesso, DataTableResultadoVue },
  data() {
    return {
      messages: [],
      notaDialog: false,
      deleteNotaDialog: false,
      deleteNotasDialog: false,
      nota: { comparecimento: false },
      selectedNotas: null,
      filters: {},
      submitted: false,
      matchModeOptions: [],

      temProcessos: false,
      processo: {
        id: null,
        nome: "",
        datHoraInicioInscricao: "",
        datHoraFimInscricao: "",
        coeficienteMinimo: null,
        areas: [],
        estadoSelecao:{cod:0}
      },
      dropdownValues: ["Não", "Sim"],
      inscricao: {
        identificador: null,
        codInscricao: null,
        candidato: null,
        coefic_red_escolar: null,
        comprovante_red_escolar_id: null,
        estado: "",
        mensagem: "",
      },

      candidato: null,
      inscricaoAntes: null,
      inscricoes: null,
      inscricoesReservadas: [],
      inscricaoDialog: false,
      deleteinscricaoDialog: false,
      deleteinscricoesDialog: false,

      processoService: null,
      resultadoProcesso: [],
      telaLoading: [],
      listaSeleacaoArea: []
    };
  },

  created() {
    this.processoService = new ProcessoService();
    this.inscricaoService = new InscricaoService();
    this.initFilters();
  },
  mounted() {
    this.getProcessoAtivo();
  },
  watch: {
  	processoSelecionado() {
      this.processo = this.processoSelecionado;
      this.getProcessoAtivo();
  	},
    telaLoading() {
      // console.log('atualizando status', this.telaLoading.some( e => e.status ));
      this.$store.state.dlgLoading = this.telaLoading.length > 0 && this.telaLoading.some( e => e.status );
    },
  },
  computed: {
    processoSelecionado: {
      get() {
        return this.$store.state.processoSelecionado;
      },
    }
  },
  methods: {
    updateStatusLoading(operacao, status) {
      //console.log("Atualizando operacao", operacao, status);
      //console.log('inicial', this.telaLoading);
      let reg = this.telaLoading.find( e => e.operacao == operacao);
      //console.log(reg);
      if (reg) {
        //console.log('removendo');
        this.telaLoading.splice(reg);
        reg.status = status;
        //console.log('incluindo');
        this.telaLoading.push(reg);
      } else {
        reg = {};
        reg.operacao = operacao;
        reg.status = status;
        this.telaLoading.push(reg);
      }
      //console.log('final', this.telaLoading);
    },
    getProcessoAtivo(){
      this.updateStatusLoading('processo', true);
      this.processoService.getProcesso(this.processoSelecionado.id)
        .then((resposta) => {
          this.processo = resposta;
          this.processo.datHoraFimInscricao = this.$formatarDataHoraBR(this.processo.datHoraFimInscricao);
          this.processo.datHoraInicioInscricao = this.$formatarDataHoraBR(this.processo.datHoraInicioInscricao);
          this.temProcessos = true;
          if (this.processo.estadoSelecao.cod > 2) {
            this.listaSeleacaoArea = this.processo.selecaoEstagioArea;
            this.listarResultado();
          }
          this.updateStatusLoading('processo', false);
        }).catch(() => {});
    },
    gerarResutadoSelecaoEstagio(idProcesso) {
      this.inscricaoService.gerarResutadoSelecaoEstagio(idProcesso)
        .then((inscricoes) => {
            this.inscricoes = inscricoes;
          // for(var i=0; i< this.inscricoes.length;i++ ){
          // if(area!= this.inscricoes[i].nomeArea) cont = 1;
          //   area = this.inscricoes[i].nomeArea;
          //   this.inscricoes[i].pos = cont;
          //   cont++
          // }
          // teste['joao'] = area;
          // console.log("inscricoes: ", JSON.stringify(this.inscricoes, null, 3));
        });
    },
    gerarResutadoSelecaoEstagioReservadas(idProcesso) {
      var area =1;
      let cont;
      this.inscricaoService
        .gerarResutadoSelecaoEstagioReservadas(idProcesso)
        .then((inscricoes) => {
          this.inscricoesReservadas = inscricoes;
            for(var i=0; i< this.inscricoesReservadas.length;i++ ){
          if(area!= this.inscricoesReservadas[i].nomeArea) cont = 1;
            area = this.inscricoesReservadas[i].nomeArea;
            this.inscricoesReservadas[i].pos = cont;
            cont++
          }

        });
    },
    gerarResutadoSelecaoEstagioGeral() {
      this.$store.state.dlgLoading = true;
      this.processoService.gerarResutadoSelecaoEstagio(this.processo).then((processo) => {
                this.listarResultado()
                // this.gerarResutadoSelecaoEstagio(processo.id);
                // this.gerarResutadoSelecaoEstagioReservadas(processo.id);
                this.processo.estadoSelecao = processo.estadoSelecao;
                this.$store.state.dlgLoading = false;
              })
              .catch((erro) => {
                this.messages = this.getMessagesError(erro);
                this.$store.state.dlgLoading = false;
              });
    },
    listarResultado() {
      this.updateStatusLoading('listarResultado', true);
      this.processoService.listarResultado(this.processo.id)
          .then((resultado) => {
            this.resultadoProcesso = resultado;
            this.updateStatusLoading('listarResultado', false);
          })
          .catch((erro) => {
            this.updateStatusLoading('listarResultado', false);
            this.messages = this.getMessagesError(erro);
          });
    },
    listarResultadoArea(resultadoArea) {
      this.updateStatusLoading('listarResultado', true);
      this.processoService.listarResultadoArea(resultadoArea.id)
          .then((resultado) => {
            let areaIndex = this.listaSeleacaoArea.findIndex( sa => sa.id == resultadoArea.id );
            let area      = this.listaSeleacaoArea[areaIndex]

            area.listaAmpla = resultado.listaAmpla;
            area.listaConvenio = resultado.listaConvenio;
            area.listaDeficiencia = resultado.listaDeficiencia;

            this.listaSeleacaoArea.splice(areaIndex, 1, area);

            this.updateStatusLoading('listarResultado', false);

          })
          .catch((erro) => {
            console.log(erro);
            this.updateStatusLoading('listarResultado', false);
            this.messages = this.getMessagesError(erro);
          });
    },
    exportarResultadoAmpla() {
      this.processoService.exportarResultado(this.processo.id, "AMPLA", "resultado_ampla");
    },
    exportarResultadoAmplaContato() {
      this.processoService.exportarResultadoContato(this.processo.id, "AMPLA", "resultado_ampla_contato");
    },
    exportarResultadoDeficiencia() {
      this.processoService.exportarResultado(this.processo.id, "DEFICIENCIA", "resultado_deficiencia");
    },
    exportarResultadoConvenio() {
      this.processoService.exportarResultado(this.processo.id, "CONVENIO", "resultado_convenio");
    },
    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString();
    },
    initFilters() {
      this.filters = {
        comparecimento: { value: null, matchMode: FilterMatchMode.EQUALS },

        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    openNew() {
      this.nota = {};
      this.submitted = false;
      this.notaDialog = true;
    },
    hideDialog() {
      this.notaDialog = false;
      this.submitted = false;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.notas.length; i++) {
        if (this.notas[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    addMessageError(errors) {
      for (let i = 0; i < errors.length; i++) {
        this.messages.push({
          severity: "error",
          content: `${errors[i].message}`,
        });
      }
    },
    onToggle(seleacaoArea) {
      if (!seleacaoArea.listaAmpla) {
        this.listarResultadoArea(seleacaoArea);
      }
    }
  },
};
</script>
